import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './acceptShipmentModalComponent.css';
import acceptShipmentModal from '../../../src/assets/images/acceptShipment.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchShipments, updateShipmentProductQtyReceived, receiveShipmentById } from '../../redux/shipmentSlice';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const AcceptShipmentModalComponent = ({ data,
  isOpen, onClose, filters, pageSize, pageNumber
}) => {
  console.log("dataaaaaaaaaaaaaaaaaaaaaaaaa", data, "isOpen", isOpen);
  const [open, setOpen] = React.useState(false);
  const [textValue, setTextValue] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [textValues, setTextValues] = useState({}); 
  const [errors, setErrors] = useState({}); 
  const dispatch = useDispatch();

  const handleSubmit = () => {
    console.log('Text submitted:', textValues);
    // Condition to restrict submit if any textfield is empty
    if(data.shipmentProducts.length === Object.keys(textValues)?.length){
      for (const [shipmentProductId, productQtReceived] of Object.entries(textValues)) {
        console.log(`shipmentProductId ID: ${shipmentProductId}, Quantity: ${productQtReceived}`);
        dispatch(updateShipmentProductQtyReceived({shipmentId:data.shipmentId, shipmentProductId, productQtReceived})) //TODO: To check it later
    }
      dispatch(receiveShipmentById({shipmentId:data.shipmentId, receive:'true'}))
      .then(() => {
        console.log("brand forest ship12 brand forest ship12 brand forest ship12")
        const queryParams = {
          type: 'incoming',
          searchText: filters.search || '',
          fromDate: filters.fromDate || '',
          toDate: filters.toDate || '',
          shipmentStatus: filters.shipmentStatus || '',
          pageSize, 
          pageNumber, 
        };
        dispatch(fetchShipments(queryParams));
      })
      onClose();
    }
  };
  //  const handleTextChange = (e) => {
  //   setTextValue(e.target.value);
  //  };

  const handleCheckboxChange = () => {
    if (!isChecked) {
        const updatedValues = {};
        data.shipmentProducts.forEach(product => {
            updatedValues[product.shipmentProductId] = product.productQty;
        });
        setTextValues(updatedValues); // Updating text field values with product quantities
    } else {
        setTextValues({}); // Reset text field values if checkbox is unchecked
    }
    setIsChecked(!isChecked);
};

const handleTextChange = (productId) => (event) => {
  const newValue = event.target.value;
  console.log("newValue",newValue)
  setTextValues(prevValues => ({
      ...prevValues,
      [productId]: newValue
  }));

  // Custom validation on quantities entered
  const value = parseFloat(newValue);
  const productQty = data.shipmentProducts.find(product => product.shipmentProductId === productId)?.productQty || 0;
  if (isNaN(value) || value <= 0 || value > productQty) {
      setErrors(prevErrors => ({
          ...prevErrors,
          [productId]: 'Invalid quantity'
      }));
  } else if (!newValue) { 
    setErrors(prevErrors => ({
        ...prevErrors,
        [productId]: 'This field is required' 
    }));
} else {
    setErrors(prevErrors => ({
        ...prevErrors,
        [productId]: ''
    }));
}
};

  // const handleSubmit = () => {
  //    console.log('Text submitted:', textValue);
  //   //  dispatch();
  //    onClose();
  // };

  // const handleClickOpen = () => {
  //   // setOpen(true);
  //   // onClose();
  // };
  
  const handleClose = () => {
    // setOpen(false);
    onClose(false);
  };

  return (
    <React.Fragment >
      {/* <button className="icon-clay delete" onClick={handleClickOpen}>
                    <span class="inner-clay color-red"> <img src={receiveIcon} alt="Receive" /></span>
                </button> */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        // open={open}
        open={isOpen}
        className='shipmentAcceptModalBody'

      >
        <DialogTitle sx={{ m: 0, p: "0px 39px " }} shipmentProductId="customized-dialog-title">
          {/* Modal title */}
          <div className='acceptmodalImagediv'>
            <img
              className='accepmodalImage'
              src={acceptShipmentModal}
            />
            <h4 className='headingForAcceptShipmentModal'> Accept Shipment </h4>
            <h6 className='subHeading1ForAcceptShipmentModal'> Accept complete or partial </h6>
            <h6 className='subHeading2ForAcceptShipmentModal'> shipment </h6>
          </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
              <DialogContent dividers>
                <Typography gutterBottom>
                  {/* <h4 className='titleHeadingForModal'>Total Pieces : 8</h4> */}
                  <input
                    type="checkbox"
                    checked={isChecked} 
                    onChange={handleCheckboxChange} 
                  />
                  <span className='titleHeadingForModal'>Check to auto fill the products quantity</span>
                  {data && data.shipmentProducts.map((product, index) =>
                    <><h4 className='titleHeading1ForModal'>{product.productName}</h4>
                      <div className='shipmentAcceptModalTextField' >
                      <TextField
                            label="Enter here"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                                style: {
                                    height: "20px",
                                },
                            }}
                            sx={{
                                width: "300px",
                            }}
                            value={textValues[product.shipmentProductId] || ''} 
                            onChange={handleTextChange(product.shipmentProductId)} 
                            margin="normal"
                            error={Boolean(errors[product.shipmentProductId])} 
                            helperText={errors[product.shipmentProductId]} 
                            type="number" 
                            required
                        />

                        <span className="quantityValue">{product.productQty}</span>
                      </div></>)}
                </Typography>

              </DialogContent>
              <DialogActions>
              <Button autoFocus onClick={handleSubmit} variant="contained" color="primary" 
            style={{width:"400px", marginRight: "19%",marginLeft:"20%", backgroundColor: "lightgrey", textDecoration:"white"}}
          >
            Verify and save
          </Button>
              </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default AcceptShipmentModalComponent;


